<template>
	<div>

		<el-card class="box-card">

			<el-form :inline="true" :model="dataForm" @keyup.enter.native="network().getArticleCategory()">
				<el-form-item>
					<el-input style="width: 20rem;margin-right: 20px;" v-model="dataForm.keyword" placeholder="请输入分类名称"
						clearable suffix-icon="el-icon-search">
					</el-input>
					<el-select v-model="dataForm.parent_id" placeholder="请选择所属类目">
						<el-option v-for="item in lmList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="network().getArticleCategory()">搜索</el-button>
					<el-button @click="event().clearSearch()">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right;" v-if="uuid != 1">
					<el-button type="primary" @click="addAdminClick('新增')">新增分类</el-button>
				</el-form-item>
				<!-- <el-form-item style="float: right;">
				<el-button type="primary" @click="network().regionexport()">导出</el-button>
			</el-form-item> -->
			</el-form>
			<el-table :data="tableData" border style="width: 100%" class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}">
				<el-table-column type="index" label="序号" align="center" width="200">
				</el-table-column>
				<el-table-column prop="title" label="分类名称" align="center">
				</el-table-column>
				<el-table-column prop="num" label="所属类目" align="center">
					<template slot-scope="scope">
						{{scope.row.parent?scope.row.parent.title:'全部'}}
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="创建时间" align="center">
				</el-table-column>
				<el-table-column label="操作" width="250px" align="center" fit>
					<template slot-scope="scope">
						<div class="operation-wrap">
							<span class="operation-item" @click="editCityList(scope.row)">
								<i class="el-icon-edit"></i>编辑</span>
							<span class="operation-item delete" @click="deleteClick(scope.row)">
								<i class="el-icon-delete"></i>删除</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<common-dialog :title="dialogTitle" :dialogVisible="dialogVisible" @cancel="dialogCancelClick"
				@confirm="dialogConfirmClick" @dialog-close="dialogClose">
				<div class="dialog-body-wrap">
					<div v-if="dialogType ==='delete'">
						是否删除分类？
					</div>
				</div>
			</common-dialog>
			<CategoryDialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog"
				@confirm="confirmDialog">
			</CategoryDialog>
			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>

		</el-card>
	</div>
</template>

<script>
	import operations from "@/mixins/operations";
	import CategoryDialog from './components/CategoryDialog.vue'
	import CommonDialog from "@/components/CommonDialog";
	import {
		getArticleCategory,
		deleteArticleCategory,
		regionexport
	} from "@/api/school-manage"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"
	import CommonPagination from "@/components/CommonPagination";

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				total: 0,
				page_size: 10,
				page_index: 1,
				tableData: [],
				dataForm: {
					keyword: null,
					parent_id:null
				},
				uuid: '',
				//删除弹框开始
				dialogTitle: "",
				dialogType: "",
				dialogVisible: false,
				form: {},
				//删除弹框结束
				//添加/修改
				selectForm: {},
				editdialogVisible: false,
				lmList: [{
						id: '007889c8b35bedb57876ac91f9dffc1e',
						name: '研发灵感'
					},
					{
						id: '11aa6cec60c96d23c50b8c9ff57d9427',
						name: '产品灵感'
					},
					{
						id: '54e29715-d06f-0e6168c7dfa79b594d',
						name: '营销灵感'
					},
					{
						id: '9f865cdc4ee64131a2abdb8e6762cdb4',
						name: '全部'
					}
				]
			};
		},
		components: {
			CategoryDialog,
			CommonDialog,
			CommonPagination
		},
		mounted() {
			this.network().getArticleCategory();
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			editCityList(row) {
				this.selectForm = row
				this.editdialogVisible = true;
			},
			//删除弹框开始
			dialogCancelClick: () => {
				this.dialogVisible = false
			},
			async dialogConfirmClick() {
				if (this.dialogType === "delete") {
					let postData = {
						uuid: this.form.uuid
					}
					const {
						status
					} = await deleteArticleCategory(postData);
					this.$message.success('删除成功')
					if (status === 200) {
						this.dialogVisible = false;
						return;
					}
				}
			},
			dialogClose() {
				this.dialogVisible = false;
				this.network().getArticleCategory();
			},
			deleteClick(row) {
				this.form = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.dialogType = "delete";
				this.dialogTitle = "删除分类";
			},
			//删除弹框结束
			//添加
			addAdminClick() {
				this.selectForm = {};
				this.selectForm.role_uuid = this.uuid
				this.editdialogVisible = true;
			},
			//修改
			editAdminClick(row) {
				this.editdialogVisible = true;
				this.selectForm = row;
			},
			closeDialog(row) {
				console.log(row)
				this.editdialogVisible = row;
			},
			confirmDialog(row) {
				this.editdialogVisible = row;
				this.network().getArticleCategory()
			},
			handlePageChange(page) {
				this.event().handlePageChange(page);
			},
			handleSizeChange(size) {
				this.event().handleSizeChange(size);
			},
			//添加修改结束
			/**
			 *触摸，响应事件放在event下，如onclick函数,onchange函数等
			 *特殊情况:像一些需要接收参数的事件，如onchange原生事件或者是vue中的emit有参数的事件,必须得写在event外部，否则无法得到接收参数。像这种事件特殊处理
			 **/
			event() {
				return {
					clearSearch: () => {
						this.dataForm.keyword = null
						this.dataForm.parent_id = null
						this.page_index = 1
						this.network().getArticleCategory()
					},
					toggleTab: (index) => {
						this.allChioce = [];
						this.dataForm.is_blacklist = index
						this.network().getArticleCategory();
					},
					handlePageChange: (page) => {
						this.page_index = page;
						this.network().getArticleCategory();
					},
					handleSizeChange: (size) => {
						this.page_size = size;
						this.network().getArticleCategory();
					},
				}
			},
			/**
			 *网络访问相关函数
			 **/
			network() {
				return {
					getArticleCategory: async () => {
						let postData = {
							page_size: this.page_size,
							page_index: this.page_index,
							parent_id: this.dataForm.parent_id,
							keyword_search: this.dataForm.keyword
						};
						const {
							status,
							data
						} = await getArticleCategory(postData);
						if (status !== 200) return;
						this.tableData = data.result.data.filter(item=>{
							return item.title!='研发灵感' &&item.title!='产品灵感'&&item.title!='营销灵感'
						});
						this.total = data.result.total;
					},
					regionexport: async () => {
						let postData = {
							page_size: this.page_size,
							page_index: this.page_index,
							op: {
								area_name: 'LIKE'
							},
							filter: {
								area_name: this.dataForm.keyword,
								parent_id: 0
							}
						};
						const {
							status,
							data
						} = await regionexport(postData);
						if (status !== 200) return;
						utils.blobLoadDownLoad(data, "城市列表.xls");
					},
				}
			},
			/**
			 * 一般放处理业务逻辑较多的私人函数
			 **/
			handler() {
				return {
					handleListA(list) {
						for (var i = 0; i < list.length; i++) {
							//handle service
						}
					},
					/**
					 **校验表单输入
					 **/
					verifyInput() {},

				}
			}

		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.table-wrap {
		.table-wrap(5px);
	}

	.m-content {
		width: 12rem;
	}

	.m-tab {
		position: relative;
		margin-bottom: 2.1875rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.m-tab-item {
		padding-right: 2.0625rem;
		color: #8D8EA6;
		font-size: 1.375rem;
		text-align: center;
	}

	.m-tab-item-active {
		color: #409eff;
	}

	.tab-line {
		height: 2px;
		background: #409eff;
		position: absolute;
		bottom: 0;
		transition: all 0.3s ease;
	}

	.tab-line-0 {
		width: 3rem;
		left: 0;
	}

	.tab-line-1 {
		width: 5rem;
		left: 1;
	}
</style>